goog.provide('el8.appchart.dialog.customCcda');

goog.require('el8.template.appchart.dialog.customCcda');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.util.consts');
goog.require('el8.appservice.notifier');


el8.appchart.dialog.customCcda = (function(){

    var that = new el8.uiwidget.FormDialog({
        title: 'Select Sections to Export',
        modal: true,
        position: 'center',
        autoHeight: true,
        width: 350,
        contentFn: el8.template.appchart.dialog.customCcda.content
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'demographics',
                selector: ':input[name="demographics"]'
            },
            {
                name: 'allergies',
                selector: ':input[name="allergies"]'
            },
            {
                name: 'problems',
                selector: ':input[name="problems"]'
            },
            {
                name: 'functional_statuses',
                selector: ':input[name="functional_statuses"]'
            },
            {
                name: 'smoking_status',
                selector: ':input[name="smoking_status"]'
            },
            {
                name: 'medications',
                selector: ':input[name="medications"]'
            },
            {
                name: 'immunizations',
                selector: ':input[name="immunizations"]'
            },
            {
                name: 'results',
                selector: ':input[name="results"]'
            },
            {
                name: 'chief_complaint',
                selector: ':input[name="chief_complaint"]'
            },
            {
                name: 'encounters',
                selector: ':input[name="encounters"]'
            },
            {
                name: 'care_plan',
                selector: ':input[name="care_plan"]'
            },
            {
                name: 'instructions',
                selector: ':input[name="instructions"]'
            },
            {
                name: 'procedures',
                selector: ':input[name="procedures"]'
            },
            {
                name: 'vitals',
                selector: ':input[name="vitals"]'
            },
            {
                name: 'insurance',
                selector: ':input[name="insurance"]'
            }
        ]
    });

    form.addButton('save', 'Export', function() {
        el8.appservice.notifier.notify('Exporting...');
        var mapped = form.getMapped();
        var selectedSections = [];
        for (var key in mapped) {
            if (mapped.hasOwnProperty(key) && mapped[key]) {
                // mapped[key] is true/false depending on whether the checkbox is checked
                selectedSections.push(key);
            }
        }

        var url = el8Globals.PATIENT_PATH + 'ccda/export/?';
        selectedSections.forEach(function(section, index) {
            if (index !== 0) { url += '&'; }
            url += encodeURIComponent('section[]') + '=' + encodeURIComponent(section);
        });
        window.open(url);

    }, true);
    form.addCancelButton(function() {
        that.hide();
    }, false);
    that.setForm(form);


    return that;
})();
